import { render, staticRenderFns } from "./withdrawal-tab.vue?vue&type=template&id=ed7e553a&"
import script from "./withdrawal-tab.vue?vue&type=script&lang=js&"
export * from "./withdrawal-tab.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-tab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "withdrawal-tab.vue"
export default component.exports